module.exports = __webpack_public_path__ + "img/Partners 11.67de0162.png";